module.exports = __webpack_public_path__ + "assets/img/National University of Singapore.de7daf0a.jpg";